<template>
  <div id="designatronBar" class="position-absolute w-100">
    <b-navbar v-if="dEnabled || lEnabled" toggleable="md" type="dark" class="designatron">
      <b-navbar-brand v-if='dEnabled' href="#" v-b-tooltip.hover title="Designatron"><img src="../assets/designatron.svg"></b-navbar-brand>
      <b-navbar-brand v-if='lEnabled' href="#" v-b-tooltip.hover title="Logitron"><img src="../assets/logitron.svg"></b-navbar-brand>

      <b-navbar-nav v-if="dEnabled">
        <b-form-select v-model="selectedEditor" :options="editTools" class=" mt-1 mb-1 input-xs" :style="{width: '10rem'}" />
      </b-navbar-nav>
      <b-navbar-nav class="ml-2 designatron-wiki">
        <span @click="openWiki" v-b-tooltip.hover title='Designatron Wiki Link'><icon name="question-circle"></icon></span>
        <span v-if='dEnabled' class="ml-2" @click="initDtron" v-b-tooltip.hover title='Scope and comment'><icon name="sliders-h"></icon></span>
        <!--<span class="ml-2" @click="historyShow" v-b-tooltip.hover title='History of changes'><icon name="history"></icon></span>-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-2" ref="mountPoint">

      </b-navbar-nav>

    </b-navbar>


    <b-modal no-close-on-backdrop no-close-on-esc hide-header-close v-model="otfCommentShow"
        :rows="3" :max-rows="5"
        class="designatron-modal">
      <div slot="modal-header" class="designatron-modal-header">
        <p>Please, input change comment & scope</p>
      </div>
      <div class="modal-body p-0">
        <b-form>
          <b-form-group label="Comment:" label-for="otfComment">
            <b-textarea id="otfComment" v-model="otfComment"></b-textarea>
          </b-form-group>
          <b-form-group label="Scope:">
            <scope-manager alert="Please set scope to enter designatron" />
          </b-form-group>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <div role="group" class="btn-group">
         <b-btn size="sm" class="float-right" variant="primary" @click="otfCancel">
           Close
         </b-btn>
         <b-btn size="sm" class="float-right" variant="success" @click="otfOk">
           Save
         </b-btn>
       </div>
       </div>
    </b-modal>
  </div>
</template>

<script>

import FieldCapturePointEditor from './map/designotron/FieldCapturePointEditor'
import FieldCapturePolylineEditor from './map/designotron/FieldCapturePolylineEditor'
import DamsPondsEditor from './map/designotron/DamsPondsEditor'
import AccessPointsEditor from './map/designotron/AccessPointsEditor'
import CentrelineEditor from './map/designotron/CentrelineEditor'
import WellEditor from './map/designotron/WellEditor'
import WellPadEditor from './map/designotron/WellPadEditor'
import WellDrainageEditor from './map/designotron/WellDrainageEditor'
import AccessTrackEditor from './map/designotron/AccessTrackEditor'
import SeismicLineRXEditor from './map/designotron/SeismicLineRXEditor'
import SeismicLineSXEditor from './map/designotron/SeismicLineSXEditor'
import NoGoEditor from './map/designotron/NoGoEditor'
import ConstraintsEditor from './map/designotron/ConstraintsEditor'
import Polytron from './map/designotron/Polytron'
import SubSurfacePolyEditor from './map/designotron/SubSurfacePolyEditor'
import SubSurfacePolyEditorV2 from './map/designotron/SubSurfacePolyEditorV2'
import SubSurfacePolyEditorV3 from './map/designotron/SubSurfacePolyEditorV3'
import SubSurfacePolyEditorV4 from './map/designotron/SubSurfacePolyEditorV4'
import SubSurfacePolyEditorV5 from './map/designotron/SubSurfacePolyEditorV5'
import SubSurfacePolyEditorType_1_4_certain from './map/designotron/SubSurfacePolyEditorType_1_4_certain'
import SubSurfacePolyEditorType_1_4_CertainStepout from './map/designotron/SubSurfacePolyEditorType_1_4_CertainStepout'
import Logitron from './map/designotron/Logitron'
import HpvEditor from './map/designotron/HpvEditor'
import LpdEditor from './map/designotron/LpdEditor'
import LpdSkipEditor from './map/designotron/LpdSkipEditor'
import ValveEditor from './map/designotron/ValveEditor'
import WorkpackEditor from './map/designotron/WorkpackEditor'
import LteEditor from './map/designotron/LteEditor'
import TieinEditor from './map/designotron/TieinEditor'
import WellZoneEditor from './map/designotron/WellZoneEditor'
import WellWaterZoneEditor from './map/designotron/WellWaterZoneEditor'
import TracklogPointEditor from './map/designotron/TracklogPointEditor'
import TracklogLineEditor from './map/designotron/TracklogLineEditor'

import ElectricEditor from './map/designotron/ElectricEditor'
import CWPEditor from './map/designotron/CWPEditor'
import FacilityCommonInfrastucture from './map/designotron/FacilityCommonInfrastucture'
import ProposedHaulageRoutes from './map/designotron/ProposedHaulageRoutes'
import GeotechLocations from './map/designotron/GeotechLocations'
import TrackBufferPoint from './map/designotron/TrackBufferPointEditor'
import WaterTakeOff from './map/designotron/WaterTakeOff'
import RmuEditor from './map/designotron/RmuEditor'
import TransformerEditor from './map/designotron/TransformerEditor'
import ElectricCableEditor from './map/designotron/ElectricCableEditor'
import EWAEditor from './map/designotron/EwaEditor'
import DevelopmentAreasEditor from './map/designotron/DevelopmentAreasEditor'
import FibrePitEditor from './map/designotron/FibrePitEditor'
import SequencePolygonEditor from './map/designotron/SequencePolygon'

import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/sliders-h'
import 'vue-awesome/icons/history'

import * as Polygon from 'ol/geom/Polygon'
import Feature from 'ol/Feature'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'

import Vue from 'vue'
// import Feature from 'ol/feature'

import asyncMap from 'async/series'
import ScopeManager from './map/designotron/ScopeManager'
import HistoryTool from './HistoryTool'

export default {
  name: 'designatron-tool',
  components: {HistoryTool, ScopeManager},
  created () {
    this.currentInstance = null
    this.scopeLayer = null
  },
  data () {
    return {
      commentSaved: false,
      otfStatusId: 0,
      otfIssueId: null,
      otfCreateNew: false,
      otfCommentShow: false,
      selectedEditor: null,
      issueStatuses: [],
      otfIssues: [],
      otfIssuesRaw: [],
      otfProject: null,
      editTools: [],
      // TODO: clean how tools related to layers
      initTools: [
        {
          value: 'field_point_capture',
          text: 'Field Point Capture',
          clazz: FieldCapturePointEditor,
          layer: 'fr:field_capture_point'
        },
        {
          value: 'field_polyline_capture',
          text: 'Field Polyline Capture',
          clazz: FieldCapturePolylineEditor,
          layer: 'fr:field_capture_polyline'
        },
        {
          value: 'access_points',
          text: 'Access points',
          clazz: AccessPointsEditor,
          layer: 'fr:access_points'
        },
        {
          value: 'dams_ponds_capture',
          text: 'Dams Ponds Capture',
          clazz: DamsPondsEditor,
          layer: 'fr:dams_ponds'
        },
        {
          value: 'centreline',
          text: 'Centreline',
          clazz: CentrelineEditor,
          layer: 'v4:centreline'
        },
        {
          value: 'well',
          text: 'Well',
          clazz: WellEditor,
          layer: 'v4:well'
        },
        {
          value: 'wellpad',
          text: 'Wellpad',
          clazz: WellPadEditor,
          layer: 'v4:_wellpad'
        },
        {
          value: 'well-drainage',
          text: 'Well Drainage',
          clazz: WellDrainageEditor,
          layer: 'v4:_well_drainage'
        },
        {
          value: 'access-track',
          text: 'Access track',
          clazz: AccessTrackEditor,
          layer: 'v4:access_track_centreline'
        },
        {
          value: 'no_go_user_defined',
          text: 'No Go Polygon',
          clazz: NoGoEditor,
          layer: 'v4:no_go_user_defined'
        },
        {
          value: 'wardswell_rx_20230621',
          text: 'Seismic Line RX',
          clazz: SeismicLineRXEditor,
          layer: 'v4:wardswell_rx_20230621'
        },
        {
          value: 'wardswell_sx_20230621',
          text: 'Seismic Line SX',
          clazz: SeismicLineSXEditor,
          layer: 'v4:wardswell_sx_20230621'
        },
        {
          value: 'constraints',
          text: 'Constraints',
          clazz: ConstraintsEditor,
          layer: 'v4:constraints_landholder'
        },
        {
          value: 'hpv',
          text: 'HPV',
          clazz: HpvEditor,
          layer: 'v4:hpv'
        },
        {
          value: 'lpd',
          text: 'LPD Boot',
          clazz: LpdEditor,
          layer: 'v4:lpd'
        },
        {
          value: 'lpd_skid',
          text: 'LPD Skid',
          clazz: LpdSkipEditor,
          layer: 'v4:lpd_skip'
        },
        {
          value: 'valve',
          text: 'Valve',
          clazz: ValveEditor,
          layer: 'v4:valve'
        },
        {
          value: 'tracklog_point',
          text: 'tracklog_point',
          clazz: TracklogPointEditor,
          layer: 'v4:tracklog_point'
        },
        {
          value: 'tracklog_line',
          text: 'tracklog_line',
          clazz: TracklogLineEditor,
          layer: 'v4:tracklog_linestring'
        },
        {
          value: 'workpack',
          text: 'Coverage',
          clazz: WorkpackEditor,
          layer: 'v4:workpack'
        },
        {
          value: 'lte',
          text: 'LTE',
          clazz: LteEditor,
          layer: 'v4:communication_towers'
        },
        {
          value: 'tie_in',
          text: 'Tie in',
          clazz: TieinEditor,
          layer: 'v4:tie_in_locations'
        },
        {
          value: 'well_zone',
          text: 'Well allocation zone',
          clazz: WellZoneEditor,
          layer: 'v4:well_allocation_zones'
        },
        {
          value: 'well_water_zone',
          text: 'Well allocation water zone',
          clazz: WellWaterZoneEditor,
          layer: 'v4:well_allocation_zones_water'
        },
        {
          value: 'electric',
          text: 'Electric',
          clazz: ElectricEditor,
          layer: 'v4:electric_zones'
        },
        {
          value: 'polytron',
          text: 'Planning',
          clazz: Polytron,
          layer: 'v4:managementpoly_planning'
        },
        {
          value: 'sub_surface_polygon',
          text: 'Sub Surface Planning',
          clazz: SubSurfacePolyEditor,
          layer: 'v4:sub_surface_planning_polygons'
        },
        {
          value: 'sub_surface_polygon_v2',
          text: 'Sub Surface Planning V2',
          clazz: SubSurfacePolyEditorV2,
          layer: 'v4:sub_surface_planning_polygons_v2'
        },
        {
          value: 'sub_surface_polygon_v3',
          text: 'Sub Surface Planning V3',
          clazz: SubSurfacePolyEditorV3,
          layer: 'v4:sub_surface_planning_polygons_v3'
        },
        {
          value: 'sub_surface_polygon_v4',
          text: 'Sub Surface Planning V4',
          clazz: SubSurfacePolyEditorV4,
          layer: 'v4:sub_surface_planning_polygons_v4'
        },
        {
          value: 'sub_surface_polygon_v5',
          text: 'Sub Surface Planning V5',
          clazz: SubSurfacePolyEditorV5,
          layer: 'v4:sub_surface_planning_polygons_v5'
        },
        {
          value: 'type_1_4_certain',
          text: 'Type 1-4 Certain',
          clazz: SubSurfacePolyEditorType_1_4_certain,
          layer: 'v4:sub_surface_planning_polygons_type_1_4_certain'
        },
        {
          value: 'type_1_4_certain_stepout',
          text: 'Type 1-4 Certain + Stepout',
          clazz: SubSurfacePolyEditorType_1_4_CertainStepout,
          layer: 'v4:sub_surface_planning_polygons_type_1_4_certain_plus_stepout'
        },
        {
          value: 'cwp',
          text: 'CWP',
          clazz: CWPEditor,
          layer: 'v4:management_poly_planning_cwp'
        },
        {
          value: 'facilities_commoninfrastructure',
          text: 'Facility Common Infrastucture',
          clazz: FacilityCommonInfrastucture,
          layer: 'v4:facilities_commoninfrastructure'
        },
        {
          value: 'route',
          text: 'Proposed Haulage Routes',
          clazz: ProposedHaulageRoutes,
          layer: 'v4:proposed_haulage_routes'
        },
        {
          value: 'geotech_locations',
          text: 'Geotech Locations',
          clazz: GeotechLocations,
          layer: 'v4:geotech_locations'
        },
        {
          value: 'track_buffer_point',
          text: 'Access Track Buffer Point',
          clazz: TrackBufferPoint,
          layer: 'v4:track_buffer_point'
        },
        {
          value: 'water_offtakes',
          text: 'Water take off',
          clazz: WaterTakeOff,
          layer: 'v4:water_offtakes'
        },
        {
          value: 'cable_features',
          text: 'RMU',
          clazz: RmuEditor,
          layer: 'v4:cable_features'
        },
        {
          value: 'wellpad_infrastructure',
          text: 'Transformer',
          clazz: TransformerEditor,
          layer: 'v4:wellpad_infrastructure'
        },
        {
          value: 'cable',
          text: 'Electric Cable',
          clazz: ElectricCableEditor,
          layer: 'v4:cable'
        },
        {
          value: 'ewa',
          text: 'EWA',
          clazz: EWAEditor,
          layer: 'v4:ewa'
        },
        {
          value: 'development_areas',
          text: 'Development Areas',
          clazz: DevelopmentAreasEditor,
          layer: 'v4:development_areas'
        },
        {
          value: 'fibre_pit',
          text: 'Fibre Pit',
          clazz: FibrePitEditor,
          layer: 'v4:fibre_pit'
        },
        {
          value: 'sequence_polygons',
          text: 'Sequence',
          clazz: SequencePolygonEditor,
          layer: 'v4:sequence_polygons'
        }
      ]
    }
  },
  computed: {
    otfComment: {
      get () {
        return this.$store.getters['project/otfComment']
      },
      set (val) {
        this.$store.commit('project/otfComment', val)
      }
    },
    scopeAOI () {
      return this.$store.getters['map/scopeAOI']
    },
    scopeState () {
      return this.$store.getters['map/scopeState']
    },
    hideAllWidgets () {
      return this.$store.getters['map/hideAllWidgets']
    },
    dEnabled: {
      get () {
        return this.$store.getters['map/designotron']['enabled']
      },
      set (val) {
        this.$store.getters['map/designotron']['enabled'] = val
      }
    },
    wikiProjectId: {
      get () {
        return this.$store.getters['project/wikiProjectId']
      },
      set (val) {
        this.$store.getters['project/wikiProjectId'] = val
      }
    },
    lEnabled: {
      get () {
        return this.$store.getters['map/logitron']['enabled']
      },
      set (val) {
        this.$store.getters['map/logitron']['enabled'] = val
      }
    },
    user () {
      return this.$store.getters['user/user']
    },
    showSearch: {
      get() {
        return this.$store.getters['map/searchShow']
      },
      set(val) {
        this.$store.commit('map/searchShow', val)
      },
    },
    showProjectList: {
      get() {
        return this.$store.getters['project/showProjectList']
      },
      set(val) {
        this.$store.commit('project/showProjectList', val)
      },
    },
    menuRightCls: {
      get() {
        return this.$store.getters['user/menuRightCls']
      },
      set(val) {
        this.$store.commit('user/menuRightCls', val)
      }
    }
  },
  mounted () {

    this.$watch('dEnabled', (val) => {
      if (val) {



        if (location.href.includes('local')) {
          this.initializeTools()
        }

        this.$http.get('/api/admin-board/workpack-redmine-issue', {
          params: {
            id: this.$store.getters['project/currentProject'].workpack.id
          }
        })
          .then(res => {
            // On designatron open ensure clear scope
            this.$store.commit('map/scopeAOI', null)
            this.$store.commit('map/scopeState', null)

            this.initDtron()
            // this.editTools = this.initTools

            //tmp solution, need to debug why sometimes layers are duplicated
            let fixMap = {

            }

            if (this.editTools.length == 0) {

              this.editTools.push({
                value: null,
                text: 'No editor selected',
                clazz: null,
              })

              this.initTools.sort(function(a, b) {
                var textA = a.text
                var textB = b.text
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
              })

              this.initializeTools()
            }

            this.lEnabled = false
            this.selectedEditor = null
            this.showSearch = false
            this.showProjectList = false
            this.menuRightCls = ''
            this.otfIssueId = res.body[0]['redmine_issue_id']
            if (this.$store.getters['map/phaseOptions'].length == 0) {
              this.getPhaseData()
            }
          }, r => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get current workpack redmine issue',
              type: 'error'
            })

            // this.editTools.push(this.initTools[0])
            this.initializeTools()

            this.lEnabled = false
            this.selectedEditor = null
          })
      } else {
        // On designatron close remove scope
        this.$store.commit('map/scopeAOI', null)
        this.$store.commit('map/scopeState', null)
      }
    })
    // this.initWebSocket()
    this.loadOtfStuff()
  },
  watch: {
    scopeState (val) {
      if (val !== 'custom_before') {
        this.clearScope()
        if (val) {
          this.$mapService.toWfs()
          if (this.scopeAOI) {
            this.drawScope(this.scopeAOI)
          }
        } else {
          this.$mapService.toWms()
        }

        // This was likely needed in the past when we would transform layers from wms to wfs. This has largely been phased out as it did not perform well and was not used often.

        // this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
        //   if (((node['data_type'] === 'wfs' ) || (node['transformable'] && node['data_type'] === 'wms' )) && node['checked']) {
        //     this.$mapService.forceCreateLayer(node)
        //   }
        // })
      }
    },
    hideAllWidgets (val) {
      if (this.$store.getters['map/designotron']['enabled']) {
        this.otfCommentShow = !val
      }

      this.$store.commit('project/showWidgetGrid', !val)
    },
    lEnabled (val) {
      if (val) {
        this.dEnabled = false
        this.editTools = [
          {
            value: 'logitron',
            text: 'Logitron',
            clazz: Logitron,
          }
        ]
        // TODO: clean
        let me = this
        setTimeout(function(){
          me.selectedEditor = 'logitron'
        }, 100);
      } else {
        this.unmountCurrent()
      }
    },
    selectedEditor (val) {
      if (val) {
        let options = this.editTools.filter(t => t.value === val)[0]
        this.unmountCurrent()

        let ComponentClass = Vue.extend(options.clazz)
        let instance = new ComponentClass({
          propsData: {
            'editorIdent': options.value,
            'editorName': options.text
          }
        })
        instance.$mount()
        this.currentInstance = instance
        $(this.$refs.mountPoint).append(instance.$el)
      } else {
        this.unmountCurrent()
      }
    },
  },
  methods: {
    initializeTools() {
      this.editTools.splice(0, this.editTools.length)
      let m = {}
      // this.editTools = []
      this.initTools.forEach(i => {
        this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
          if (i.layer && i.layer.indexOf(node['name']) > -1 && node['editable']) {
            // this.editTools.push(i)
            m[i.layer] = i
          }
        })
      })


      for(var k in m) {
        this.editTools.push(m[k])
      }
    },
    initDtron(e) {
      console.log(location.host.includes('local'))
      if (location.host.includes('local')) {
        this.otfComment = 'local development'
        console.log('skipping otf')
      } else {
        this.otfCommentShow=true
      }
    },
    historyShow () {
      let opts = {
        available: true,
        enabled: true,
        clazz: HistoryTool,
        w: 8,
        h: 4,
        x: 3,
        y: 0,
        propsData: {

        },
        destroyable: true
      }

      this.$store.commit('cmp/update', {
        cmp: 'history',
        payload: opts
      })
    },
    drawScope(aoi) {
      let poly = Polygon.fromExtent(aoi.split(',').map(n => parseFloat(n)))

      let style = new Style({
        fill: new Fill({
          color: [255, 255, 255, 0]
        }),
        stroke: new Stroke({
          color: '#ff0066',
          width: 3
        }),
        points: 4,
        radius: 7,
        angle: Math.PI / 4
      })
      this.scopeLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature(poly)
          ]
        }),
        style: style
      })

      this.$mapService.map.addLayer(this.scopeLayer)
    },
    clearScope() {
      this.$mapService.map.removeLayer(this.scopeLayer)
    },
    getPhaseData () {
      this.$http.get('/api/layers/get-phase-data')
        .then(res => {
          this.$store.commit('map/phaseOptions', res.body)
        }, r => {
          clb('error')
        })
    },
    openWiki () {
      let win = window.open('/mine/projects/' + this.wikiProjectId + '/wiki/Designatron')
      win.focus()
    },
    otfCancel () {
      if (!this.commentSaved) {
        this.dEnabled = false
        this.selectedEditor = null
      }

      this.otfCommentShow = false
    },
    loadOtfStuff () {
      asyncMap([
        (clb) => {
          this.$http.get('/api/layers/otf-redmine-project')
            .then(res => {
              clb(null, res.body.project_id)
            }, r => {
              clb('error')
            })
        }
      ], (err, res) => {
        if (err) {
          this.$notify({
            title: 'ERROR',
            text: 'Could not fetch OTF redmine project',
            type: 'error'
          })
          return
        }
        let [projectId] = res
        this.otfProject = parseInt(projectId)
      })
    },
    otfOk (e) {
      if (!this.otfComment) {
        this.$notify({
          title: 'ERROR: empty',
          text: 'Comment is required',
          type: 'error'
        })
        e.preventDefault && e.preventDefault()
        return false
      }

      if (!this.scopeState) {
        this.$notify({
          title: 'ERROR: empty',
          text: 'Scope is required',
          type: 'error'
        })
        e.preventDefault && e.preventDefault()
        return false
      }

      if (!this.otfIssueId && !this.otfCreateNew) {
        this.$notify({
          title: 'ERROR: empty',
          text: 'Issue is required',
          type: 'error'
        })
        e.preventDefault && e.preventDefault()
        return false
      }
      this.saveOtfComment()
      this.otfCommentShow = false
    },
    saveOtfComment () {
      this.selectedEditor = null
      this.$http.post('/api/layers/otf-comment/', {
        comment: this.otfComment,
        issue_id: this.otfIssueId,
        workpack_id: this.$store.getters['project/currentProject'].workpack.id,
        project_id: this.otfProject,
        // status_id: this.otfStatusId,
        create_new: this.otfCreateNew
      })
        .then(res => {
          this.$notify({
            title: 'Done!',
            text: 'Successfully saved comment',
            type: 'success'
          })
          this.commentSaved = true
        }, res => {
          this.$notify({
            title: 'WARNING',
            text: 'Comment not saved',
            type: 'warning'
          })
          this.commentSaved = false
        })
    },
    unmountCurrent() {
      if (this.currentInstance) {
        this.currentInstance.$destroy()
        $(this.currentInstance.$el).remove()
        this.currentInstance = null
      }
    },
    initWebSocket () {
      let me = this
      let p = location.protocol.indexOf('https') > -1 ? 'wss' : 'ws'
      let url = `${p}://${location.hostname}${location.port ? ':' + location.port : ''}/ws/designotron/`

      let socket = new WebSocket(url)

      socket.onmessage = function (e) {
        let data = JSON.parse(e.data)

        // perhaps we should check by some session token, but for now username
        if (data.data.username === me.user.username) {
          // console.log('same user')
          return
        }
        if (data.data && data.data.action) {
          let exists = me.$mapService._layerExists({"id": data.data.layerKegsId})
          if (!exists) {
            return
          }

          let dSource = exists.getSource()
          switch (data.data.action) {
            case 'add':
              dSource.addFeatures(data.data.features.map(f => {
                let feature = new Feature(me.wkt.readGeometry(f.geo))
                feature.setProperties(f.properties, true)
                return feature
              }))
              break
            case 'edit':
              data.data.features.forEach(f => {
                exists.getSource().getFeatures().forEach(ff => {
                  let iField = 'ident'
                  // console.log(iField)
                  // console.log(f.properties)
                  if (!f.properties[iField]) {
                    return
                  }
                  if (ff.get(iField) === f.properties[iField]) {
                    ff.setGeometry(me.wkt.readGeometry(f.geo))
                    ff.setProperties(f.properties, true)
                  }
                })
              })
              break
            case 'delete':
              data.data.features.forEach(f => {
                dSource.getFeatures().forEach(ff => {
                  if (ff.get(data.data.idName) === f.properties[data.data.idName]) {
                    dSource.removeFeature(ff)
                  }
                })
              })
              break
          }
        }
      }

      socket.onclose = function (e) {
        console.error('socket closed unexpectedly')
      }

      socket.onopen = () => {
        console.log('WEB SOCKET OPENED!')
        socket.send(JSON.stringify({
          username: this.user.username,
          ts: new Date().getTime(),
          browser: navigator.userAgent
        }))
      }
      window.webSocket = socket
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Designatron.vue